import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {  OktaAuth } from '@okta/okta-auth-js';
import {  OKTA_AUTH } from '@okta/okta-angular';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    public router: Router,
    @Inject(OKTA_AUTH) private readonly _oktaAuth: OktaAuth
  ) { }

  userTypeId: number;
  
  /**
  *isAuthenticated() - method to check if the user is signed in or not
  */
  isAuthenticated(): any {
    return this._oktaAuth.isAuthenticated();
  }

  /**
 * getUser Role() - Retrieves the role of the authenticated user from local storage.
 */
  
  getUserRole(): any {
    // Return the role of the authenticated user
    const userProfile = JSON.parse(localStorage.getItem('user-profile'));
    this.userTypeId = userProfile.userTypeId;
    switch (this.userTypeId) {
      case 1:
        return "customer";
      case 2:
        return "studio";
      case 3:
        return "ar";
      default:
        return ""
    }
  }

}
